import React, { useState, useEffect } from 'react';
import styles from '../styles/Member.module.css';
import { fetchData } from '../utils/apiClient';

function Member() {
    // モックデータ (SQLが読み込めない場合のフォールバック)
    const mockMembers = [
        {
            id: 1,
            name: 'T.Yamashita',
            role: 'プロデューサー・代表',
            history: '・一橋大学卒。人材・広告会社勤務\r\n・グローバル事業統括（オランダ駐在）を経て2022年Parnas創業',
            qna: [
                { question: 'リガーになったきっかけを教えてください。', answer: '私自身はリグはできません。会社設立前に多くの制作会社からリガー不足の声を頂き、リグの会社を作りました。最近はPythonスクリプトを覚え、社内ツールの改修などを担当しています。' },
                { question: 'Parnas入社前の経験を教えてください。', answer: '前職では会計の仕事を中心でキャリアを積みました。縁あってM＆Aで買収した海外子会社の統括として3年ほど欧州に駐在してグローバルでのマネジメントや人材事業について理解を深めました。' },
                { question: '得意なこと、苦手なことを教えてください。', answer: '得意なこと：好奇心を持って様々なことに取り組むこと。苦手なこと：同じ作業を続けること。' },
                { question: 'Parnasに入ってわかったこと・意外だったことを教えてください。', answer: 'リグの仕事の奥深さは想像以上でした。各プロジェクトに貢献できるよう日々勉強です。' },
                { question: '今後のキャリアのイメージなどがあれば教えてください。', answer: 'いざという時に頼りになる、そんな会社になりたいです。' }
            ],
            image_path: '/images/member/web_member_squid_04.png'
        },
        {
            id: 2,
            name: 'R.Yanagi',
            role: 'リードリギングアーティスト',
            history: '・リガーとしてCG制作会社6年勤務\n・多数のTVアニメ、映像作品制作に従事\n・キャラクターリギングに強み',
            qna: [
                { question: 'リガーになったきっかけを教えてください。', answer: '学生時代にかっこいいポージングをつけたくてリギングを授業＋独学で学んでいたため' },
                { question: 'Parnas入社前の経験を教えてください。', answer: 'リガーとして４年、ジェネラリストとして２年勤めていました。' },
                { question: '得意なこと、苦手なことを教えてください。', answer: '得意なことが得意！こう見えて苦手なことは苦手です！' },
                { question: 'Parnasに入ってわかったこと・意外だったことを教えてください。', answer: '社員全員向上心高い！リモートワークだから働きやすい！頑張っただけ評価してもらえる！' },
                { question: '今後のキャリアのイメージなどがあれば教えてください。', answer: 'Parnas社内にUnityについて学びたい。モデリングもできるようになって業務の幅を増やしたい。' }
            ],
            image_path: '/images/member/web_member_VRchara_01.png'
        },
        {
            id: 3,
            name: 'R.Nonaka',
            role: 'リードリギングアーティスト',
            history: '・リガー歴10年、CG業界歴12年\r\n・リギングSVとして多数のTVアニメ、映像作品、劇場アニメ制作に参加',
            qna: [
                { question: 'リガーになったきっかけを教えてください。', answer: '元々アニメーション志望で業界に入りましたが、中々芽が出ずにそんな時に向いているのではないかということで対応依頼されたのが始まりです。' },
                { question: 'Parnas入社前の経験を教えてください。', answer: 'アニメーションは約2年、リガーが約10年ほどです。また2～3年ほどモーションキャプチャーの作業者及び管理者も兼任しておりました。' },
                { question: '得意なこと、苦手なことを教えてください。', answer: '得意なこと：リギング。苦手なこと：プライベートでの片付け。' },
                { question: 'Parnasに入ってわかったこと・意外だったことを教えてください。', answer: 'parnasは全員リガーなので刺激があってとてもいいです！あとはフルリモートなので、働きやすいです！' },
                { question: '今後のキャリアのイメージなどがあれば教えてください。', answer: '自分の技術のアップデートと、管理能力の向上、育成等を強化してなんでもござれな人員を目指したいです！' }
            ],
            image_path: '/images/member/web_member_parnasKun_06.png'
        },
        {
            id: 4,
            name: 'W.Koura',
            role: 'テクニカルリギングアーティスト',
            history: '・リガーとしてCG映像会社4年、ゲーム会社シネマティクス部門1年半勤務\n・Maya Pythonツール作成に強み',
            qna: [
                { question: 'リガーになったきっかけを教えてください。', answer: '専門学生の頃のグループ制作でリグ担当になってからです。当時はアニメーター志望でした。' },
                { question: 'Parnas入社前の経験を教えてください。', answer: 'スタジオでアセットのセットアップとツール開発を4年ほど、ゲーム会社に1年半で経験を積みました。' },
                { question: '得意なこと、苦手なことを教えてください。', answer: '得意なこと : 作業中に効率化できそうな箇所を即興でスクリプト化すること。苦手なこと : 早起き。' },
                { question: 'Parnasに入ってわかったこと・意外だったことを教えてください。', answer: 'メンバーの住んでいる場所が全国バラバラだったことに驚きました。' },
                { question: '今後のキャリアのイメージなどがあれば教えてください。', answer: '多種多様なセットアップに高いクオリティで対応できる人材になること。' }
            ],
            image_path: '/images/member/web_member_VRchara_03.png'
        },
        {
            id: 5,
            name: 'A.Shibano',
            role: 'リギングアーティスト',
            history: '・CG専門学校卒業\n・アニメーションエイド リギングクラス受講\n・イラスト、モデリング、リギング、アニメーションまで幅広く対応',
            qna: [
                { question: 'リガーになったきっかけを教えてください。', answer: '山下社長との出会いがきっかけでした。モデラーやアニメーターよりもきれいなデフォームを追求するリガーの仕事が性に合っていると感じました。' },
                { question: 'Parnas入社前の経験を教えてください。', answer: '営業、内勤、IT系の仕事に就いておりました。その後CGの専門学校へ入学しました。インドへ2週間、上海へ3カ月出張したことがあります。' },
                { question: '得意なこと、苦手なことを教えてください。', answer: '得意なこと：セットアップ系。滑らかなウエイト。苦手なこと：テクニカル系。' },
                { question: 'Parnasに入ってわかったこと・意外だったことを教えてください。', answer: '思ったよりも社長や先輩方がサポートしてくださり、リモートでも報連相がスムーズにできるようになりました。' },
                { question: '今後のキャリアのイメージなどがあれば教えてください。', answer: '柳さんみたいになりたいです。リグのことなら何でもお任せあれと言える人になりたいですね。' }
            ],
            image_path: '/images/member/web_member_VRchara_02.png'
        },
        {
            id: 7,
            name: 'K.Nakano',
            role: 'リギングアーティスト',
            history: '・芸術系大学卒業、CG専門学校卒業\n・リガーとしてCG制作会社2年勤務',
            qna: [
                { question: 'リガーになったきっかけを教えてください。', answer: '専門学校でCG制作をひと通り触る過程で入り込んでいきました。' },
                { question: 'Parnas入社前の経験を教えてください。', answer: 'アニメ制作会社で2年間リガーとして働いておりました。' },
                { question: '得意なこと、苦手なことを教えてください。', answer: '食べる＆寝る＆1人遊びが得意で、絵を描くのが苦手です。' },
                { question: 'Parnasに入ってわかったこと・意外だったことを教えてください。', answer: '分からないことがあればすぐチャット・通話で聞く明確で簡潔なコミュニケーションを心がけています。' },
                { question: '今後のキャリアのイメージなどがあれば教えてください。', answer: '優秀な作業者になりたいです。コードの勉強と数学を少しずつでも勉強していきたいです。' }
            ],
            image_path: '/images/member/web_member_parnasKun_02.png'
        },
        {
            id: 9,
            name: 'Y.Daita',
            role: 'リギングアーティスト',
            history: '・大学院にてモーションキャプチャーによるアニメーション研究\n・フリーランスのモデラーとして2年活動',
            qna: [
                { question: 'リガーになったきっかけを教えてください。', answer: '山下社長に3DCG業務委託のお話を持ちかけられたのがきっかけで、本格的にリガーとしてのキャリアをスタートさせました。' },
                { question: 'Parnas入社前の経験を教えてください。', answer: '学時代、ゲーム制作サークルで活動していました。卒業後は企画職、フリーランスを経て入社しました。' },
                { question: '得意なこと、苦手なことを教えてください。', answer: '苦手：時間が迫っている状況で作業すること。' },
                { question: 'Parnasに入ってわかったこと・意外だったことを教えてください。', answer: 'リギングという工程の奥深さを痛感しています。職人気質な面とエンジニアの知識の両方が必要だと感じました。' },
                { question: '今後のキャリアのイメージなどがあれば教えてください。', answer: 'よりスキルの幅を広げ、ゲームエンジン等でもリッチな表現ができるようになりたいです。' }
            ],
            image_path: '/images/member/web_member_squid_03.png'
        },
        {
            id: 11,
            name: 'R.Kataoka',
            role: 'リギングアーティスト',
            history: '・医療系大学卒業。病院勤務後、CGスクール卒業',
            qna: [
                { question: 'リガーになったきっかけを教えてください。', answer: 'ポートフォリオ作成中にリギングが面白いと思い、パルナスにインターンとして応募したのがきっかけです。' },
                { question: 'Parnas入社前の経験を教えてください。', answer: '短期間コメディカルとして病院に勤務。実際の動物の手術実習をしたことがあります。' },
                { question: '得意なこと、苦手なことを教えてください。', answer: '得意なこと：知らない分野に飛び込むこと。苦手なこと：整理整頓。' },
                { question: 'Parnasに入ってわかったこと・意外だったことを教えてください。', answer: '先輩方がそれぞれのアプローチで答えてくれるので、リモートへの不安は杞憂に終わりました。' },
                { question: '今後のキャリアのイメージなどがあれば教えてください。', answer: '諸先輩方に問題なく仕事を任せていただけるような一人前のリガーになることです。' }
            ],
            image_path: '/images/member/web_member_squid_02.png'
        },
        {
            id: 12,
            name: 'Y.Toyama',
            role: '顧問',
            history: '・あらた監査法人／公認会計士\n・リクルート英国財務統括会社Director',
            qna: [],
            image_path: '/images/member/web_member_squid_05.png'
        }
    ];

    const [members, setMembers] = useState(mockMembers); // 初期値としてモックをセット
    const [selectedMember, setSelectedMember] = useState(null);
    const [openQuestionIndex, setOpenQuestionIndex] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // APIからメンバー情報を取得
    useEffect(() => {
        const fetchMembers = async () => {
            try {
                const data = await fetchData('/api/getMembers.php');
                if (data.status === 'success') {
                    setMembers(data.data);
                } else {
                    console.warn(`サーバーエラー: ${data.message || '不明なエラー'} - モックデータを使用します。`);
                }
            } catch (err) {
                console.warn(`データ取得失敗: モックデータを使用します。`);
            } finally {
                setLoading(false);
            }
        };


        fetchMembers();
    }, []);

    const handleMemberClick = (member) => {
        // スマホ画面（768px以下）ではポップアップを表示しない
        if (window.innerWidth <= 768) {
            return;
        }
        setSelectedMember(member);
        setOpenQuestionIndex(null);
    };

    const closePopup = () => {
        setSelectedMember(null);
        setOpenQuestionIndex(null);
    };

    const toggleQuestion = (index) => {
        setOpenQuestionIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    if (loading) {
        return <p className={styles.loading}>読み込み中...</p>;
    }

    if (error) {
        return <p className={styles.error}>{error}</p>;
    }

    return (
        <section className={styles.container}>
            <div className={styles.team}>
                <h2 className={styles.sectionTitle}>メンバー紹介</h2>
                <div className={styles.memberList}>
                    {members.map((member, index) => (
                        <div
                            key={index}
                            className={styles.member}
                            onClick={() => handleMemberClick(member)}
                        >
                            <img
                                src={member.image_path}
                                alt={member.name}
                                className={styles.memberImage}
                            />
                            <p className={styles.memberName}>{member.name}</p>
                            <p className={styles.memberRole}>{member.role}</p>
                        </div>
                    ))}
                </div>
            </div>

            {selectedMember && (
                <div className={styles.popupOverlay} onClick={closePopup}>
                    <div
                        className={styles.popupContent}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className={styles.memberDetails}>
                            <img
                                src={selectedMember.image_path}
                                alt={selectedMember.name}
                                className={styles.popupImage}
                            />
                            <div className={styles.memberInfo}>
                                <h3 className={styles.popupName}>{selectedMember.name}</h3>
                                <p className={styles.popupRole}>{selectedMember.role}</p>
                                <p className={styles.popupHistory}>
                                    <strong>【経歴】</strong>
                                    <br />
                                    {selectedMember.history}
                                </p>
                            </div>
                        </div>
                        <div className={styles.popupQnA}>
                            {selectedMember.qna.map((qa, index) => (
                                <div
                                    key={index}
                                    className={`${styles.questionBlock} ${openQuestionIndex === index ? styles.open : ''}`}
                                    onClick={() => toggleQuestion(index)}
                                >
                                    <strong>{qa.question}</strong>
                                    <div className={styles.answerWrapper}>
                                        <p className={styles.answer}>{qa.answer}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
}

export default Member;
